import React from 'react';
import '../../styles/Membership.css';
import '../../styles/Home.css';

export default function MembershipApply() {


  return (
    <div className='container'>
        <div className='apply-landing-container'>
            <iframe width="100%" height="600px" src="https://www.youtube.com/embed/-E9y0X4OSLw?si=vf0TafM48sn5r1xl" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
        <div className='membership-cat-container'>
            <div className='membership-cat'>
                <div className='membership-benefits-header'>Full Membership</div>
                <div className='membership-benefits-body'>
                    Telecommunication operating companies <br/>

                    • less than 100,000 subscriptions – US $ 4,500 <br/>
                    • from 100,000 to 500,000 subscriptions – US $ 8,500 <br/>
                    • more than 500,000 subscriptions – US $ 15,000 <br/>
                    • Organizations – US $ 15,000
                </div>
            </div>
            <div className='membership-cat alt'>
                <div className='membership-benefits-header'>Affiliate Membership</div>
                <div className='membership-benefits-body'>
                    Corporate Entries <br/>

                    {"• Small ( ) Revenues < US $0.5M – US $ 1,200"}<br/>
                    {"• Medium ( ) Revenues > US $0.5M but < US $ 5M – US $ 2,000"}<br/>
                    {"• Large ( ) Revenues > US $ 5M – US $ 3,600"}<br/>
                    {"• Non Profit Organizations ( ) – US $ 1,200"}<br/>

                </div>
            </div>
        </div>

        <div className='membership-cat-container'>
            <div className='membership-cat'>
                <div className='membership-benefits-header'>Instructions:</div>
                <div className='membership-benefits-body' style={{paddingRight: '50px'}}>
                    Telecommunication operating companies <br/>

                    1. Please submit a brief overview of your organization describing the nature of your business and your interest in the development of telecommunications in the Caribbean <br/>
                    2. Do not remit any fees to the Association with this application.  You will be notified of your admission to membership in the appropriate category <br/>
                    3. Dues are payable on the 1st  October of each year <br/>
                    4. Admission to membership is determined by the Board of Directors <br/>
                    5. Membership renews automatically each year unless notification of withdrawal is submitted in writing.
                </div>
            </div>
            <div className='membership-cat alt'>
                <div className='membership-benefits-header'>Policy – Members’ Fees</div>
                <div className='membership-benefits-body'>
                    Corporate Entries <br/>

                    {"• New Members joining CANTO will be required to pay fees according to the financial year of the association, i.e October 1 to September 30."}<br/>
                    {"• Therefore any fees paid within a year only cover the period up to 30 September and not beyond."}<br/>
                    {"• New members joining during the months of April to July  will be entitled to a 50% discount  of the fees due, in that 1st year of joining"}<br/>
                    {"• New members joining during the months of August  to September  will be entitled  to a 75% discount of the fees due, in that 1st year of joining"}<br/>
                    {"• A full year’s fee is due at the beginning of the next financial year."}<br/>

                </div>
            </div>
        </div>
    </div>
  )
}
